const videoCategoria = {
    AMERICANO: 1,
    BRITANICO: 2,
    INSTRUMENTAL: 3,
    HISTORIA: 4,
    EXERCICIO: 5,

    desc: (value) => {
        switch(value){
            case 1:
                return 'Americana';
            
            case 2:
                return 'Britânica';

            case 3:
                return 'Instrumental';

            case 4:
                return 'História';
            
            case 5:
                return 'Exercício';
        }
    }
}

export default videoCategoria;